// @ts-nocheck
import React, { useMemo, useEffect,useState } from 'react';
import { Route, Switch, useHistory } from 'react-router';
import { Layout } from './components/Layout';
import { Login } from './components/Login';
import { Home } from './components/Home';
import { Logout } from './components/Logout';
import { Reset } from './components/Reset';
import { Register } from './components/Register';
import { AuthProvider, useUserState } from './components/AuthProvider';
import { createTheme, ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { requestBase, parseAPIResponse } from "./Utilities/Fetch";
import Page500 from './components/Page500';
import Page404 from './components/Page404';

export const App = ({...props}) => {
  
  var userState = useUserState();
    var [auth, { setConfig    }] = userState;
    var [error, setError] = useState(null);
  var history = useHistory();

    useEffect(() => {
        let request = Object.assign({}, requestBase, { method: "GET" });

        fetch('/anywhere/api/_configuration', request)
            .then(parseAPIResponse)
            .then(config => {
             

                setConfig(config);
 


            }).catch(err=>{
             //if(err.status===404)
             //     history.replace("/NotFound", err);
             // else
             // if(err.name!=='AbortError')
             //     history.replace("/error", err);
              setError("Configuration Error: " + err.message||err);
             
          });

    }, [setConfig,setError,history]);

  const theme = useMemo(
    () =>
    {
          if (!auth?.muiTheme)
         return null;

        const defaultTheme = {
            palette: {
                mode: 'light',
                icon: {
                    main: '#16499a'
                },
                primary: {
                    main: '#16499a',
                },
                secondary: {
                    main: '#cc6600',
                },
            }
        };
          var mode = auth?.preferences?.mode || "light";

        var theme;
        if(auth?.user?.muiTheme)
            theme = auth.user.muiTheme[mode];
          if (!theme) theme = auth?.user?.muiTheme;
          if (theme && auth?.user?.muiTheme.colors && auth?.user?.muiTheme.colors[auth?.preferences.color])
        {
              var colors = auth?.user?.muiTheme.colors[auth?.preferences.color];
            theme = {...theme,  palette: {...theme.palette, ...colors} }
        }

        return createTheme(theme||defaultTheme);
    },
      [auth]);

    if (!auth.config && !error) return null;

      return (
          <AuthProvider value={userState}>
              <StyledEngineProvider injectFirst>
                  <ThemeProvider theme={theme}>
                      <CssBaseline />
 
                      {error && 
                      <Page500 error={{message:error}}></Page500>}
                      {!error && 
                      <Layout>
                          <Switch>
                            <Route exact path='/' component={!auth.config.remoteLogin?Login:null} />
                            <Route exact path='/home' component={Home} />
                            <Route exact path='/login' component={Login} />
                            <Route exact path='/logout' component={Logout} />
                            <Route exact path='/register' component={Register} />
                              <Route exact path='/reset' component={Reset} />
                            <Route path='/Error' component={Page500} />
                            <Route path='/NotFound' component={Page404} />
                          </Switch>
                      </Layout>
                      }
           
                  </ThemeProvider>
              </StyledEngineProvider>
          </AuthProvider>
      );
  
}
